import script from "./ModalQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./ModalQuestion.vue?vue&type=style&index=0&id=3646ae98&lang=scss&scoped=true"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3646ae98"]])

export default __exports__